import React, { useEffect } from 'react';
import { ArrowUp, } from 'lucide-react';
import ReactGA from 'react-ga4';
import Header from './Header';

const Footer = ({ isDarkMode,
    setSearchTerm,
    searchTerm,
    archive,
    toggleArchivedNews,
    toggleDarkMode,
    showArchived,
    darkMode = false,
    search = false,
    showArchiveButton = false,
    categories,
    setActiveCategory
}) => {

    // Cargar datos al iniciar y cuando cambien los filtros
    useEffect(() => {
    }, []);

    return (
        <>
            {/* Footer */}
            <footer className={`py-8 ${isDarkMode ? 'bg-gray-800' : 'bg-gray-100'} mt-12`}>
                <div className="container mx-auto px-4">
                    <div className="md:flex md:justify-between">
                        <div className="grid grid-cols-2">
                            <Header
                                isDarkMode={isDarkMode}
                                setSearchTerm={setSearchTerm}
                                searchTerm={searchTerm}
                                toggleDarkMode={toggleDarkMode}
                                toggleArchivedNews={toggleArchivedNews}
                                showArchived={showArchived}
                                // Show elements         
                                archive={archive}
                                darkMode={false}
                                search={false}

                            />

                            <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
                                <div>
                                    <h3 className="text-sm font-semibold mb-3 uppercase">Navegación</h3>
                                    <ul className={`space-y-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                        <li><a href="#" className="hover:text-blue-500">Inicio</a></li>
                                        <li><a href="#" className="hover:text-blue-500">Noticias</a></li>
                                        <li><a href="#" className="hover:text-blue-500">Análisis</a></li>
                                        <li><a href="#" className="hover:text-blue-500">Sobre mí</a></li>
                                    </ul>
                                </div>
                                <div>
                                    <h3 className="text-sm font-semibold mb-3 uppercase">Categorías</h3>
                                    <ul className={`space-y-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                        {categories.filter(cat => cat !== 'Todas').map(category => (
                                            <li key={category}>
                                                <a href="#" onClick={() => {
                                                    setActiveCategory(category);
                                                    ReactGA.event({
                                                        category: 'Usuario',
                                                        action: 'Click en categoría',
                                                        label: category
                                                    });

                                                }} className="hover:text-blue-500">
                                                    {category}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div>
                                    <h3 className="text-sm font-semibold mb-3 uppercase">Sígueme</h3>
                                    <div className="flex space-x-4">
                                        <a target="_blank" href="https://x.com/jmendieta78" className="text-gray-500 hover:text-blue-500">
                                            <span className="sr-only">Twitter</span>
                                            <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                                                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"></path>
                                            </svg>
                                        </a>
                                        <a target="_blank" href="https://www.linkedin.com/in/jorge-gerardo-mendieta-mayen-371a7a37/" className="text-gray-500 hover:text-blue-500">
                                            <span className="sr-only">LinkedIn</span>
                                            <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                                                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <hr className={`mt-8 border-t ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`} />
                    <div className="mt-8 flex flex-col md:flex-row md:justify-between items-center">
                        <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                            © {new Date().getFullYear()} Jorge Mendieta Mayen. Todos los derechos reservados.
                        </p>
                        <div className="flex mt-4 md:mt-0">
                            <a href="#" className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'} hover:text-blue-500 mr-4`}>
                                Políticas de Privacidad
                            </a>
                            <a href="#" className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'} hover:text-blue-500`}>
                                Términos y Condiciones
                            </a>
                        </div>
                    </div>
                </div>
            </footer>


            {/* Scroll to top button */}
            <button
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="fixed bottom-6 right-6 p-3 rounded-full bg-blue-500 text-white shadow-lg hover:bg-blue-600 transition-colors"
            >
                <ArrowUp className="w-5 h-5" />
            </button>
        </>
    )

}


export default Footer;